import React, { useState, useEffect } from 'react';
import { PhoneSlotStrip, type PhoneSlotId, type PhoneSlotProfile } from './PhoneSlotStrip';

interface SystemTrayProps {
  theme: 'dark' | 'light' | 'purple';
  onThemeToggle: () => void;
  onLogout: () => void;
  desktopTime: string;
  /** Celulares com janela aberta (CELULAR1–3). */
  activePhoneProfiles?: string[];
  onTogglePhoneSlot?: (slot: PhoneSlotId, profile: PhoneSlotProfile) => void;
}

export const SystemTray: React.FC<SystemTrayProps> = ({
  theme,
  onThemeToggle,
  onLogout,
  desktopTime,
  activePhoneProfiles = [],
  onTogglePhoneSlot,
}) => {
  const [formattedDate, setFormattedDate] = useState('');

  useEffect(() => {
    const now = new Date();
    setFormattedDate(
      now.toLocaleDateString("pt-BR", {
        day: "2-digit",
        month: "short",
        year: "numeric"
      })
      .replace(".", "")
      .toUpperCase()
    );
  }, []);

  return (
    <div className="flex items-center gap-3 select-none text-white/90">
      {/* 3 celulares fixos (EMU) — antes do horário */}
      {onTogglePhoneSlot && (
        <PhoneSlotStrip
          activeProfiles={activePhoneProfiles}
          onToggle={onTogglePhoneSlot}
          size="md"
        />
      )}

      {/* Relógio & Data Glass Pill (Estilo Imagem 2) */}
      <div 
        className="flex flex-col text-center px-4 py-1 rounded-2xl border border-white/10 shadow-lg justify-center min-w-[95px] flex-shrink-0"
        style={{
          background: 'linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.01) 100%), rgba(20,20,35,0.4)',
        }}
      >
        <span className="text-[14px] font-black text-white tracking-wider leading-none">{desktopTime}</span>
        <span className="text-[6.5px] text-[#9aa3c0] font-black uppercase tracking-widest mt-1">{formattedDate || '14 DE JUL. DE 2026'}</span>
      </div>
    </div>
  );
};
